<template>
  <div id="app">
    <h1>Curriculum Descriptor Lookup</h1>
    <DescriptorForm @lookup="handleLookup" />
    <DescriptorResults :groupedDescriptors="groupedDescriptors" />
  </div>
</template>

<script>
import DescriptorForm from "./components/DescriptorForm.vue";
import DescriptorResults from "./components/DescriptorResults.vue";

export default {
  name: "App",
  components: {
    DescriptorForm,
    DescriptorResults,
  },
  data() {
    return {
      groupedDescriptors: null,
    };
  },
  methods: {
    handleLookup(groupedDescriptors) {
      this.groupedDescriptors = groupedDescriptors;
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
